import { render, staticRenderFns } from "./EndpointSelector.vue?vue&type=template&id=581848da&scoped=true&"
import script from "./EndpointSelector.vue?vue&type=script&lang=js&"
export * from "./EndpointSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581848da",
  null
  
)

export default component.exports